import React from 'react';
import Dashboard from "./views/Dashboard";
import "./assets/scss/black-dashboard-react.scss";
import "./assets/demo/demo.css";
import "./assets/css/nucleo-icons.css";
import queryString from 'query-string';
import {getReportUrlById} from "./config";
import {useFetch} from "./hooks";
import Footer from "./components/Footer";
import NavBar from "./components/NavBar";

const App = () => {
    activateMode("light");
    const search = window.location.search && window.location.search.indexOf('id=') > 0 ? window.location.search : window.top.location.search; //window.top is use to ensure that we have access to the top window ex: in jenkins where the app is wrap in Iframe
    const param = queryString.parse(search);
    const {id} = param;
    const {response, hasError, isLoading} = useFetch(getReportUrlById(id));
    const {expiration} = response;

    if (isLoading) {
        return <h1>Report data is being fetch.</h1>;
    } else if (hasError) {
        return <h1>Report could not be generated. Verify the url.</h1>;
    } else {
        return (
            <>
                <NavBar/>
                <Dashboard reportData={response}/>
                <Footer/>
            </>
        );
    }
};

const activateMode = mode => mode === "light" ? document.body.classList.add("white-content"): document.body.classList.remove("white-content");


export default App;
